import Swal from "sweetalert2";
import { Store } from "@ngrx/store";
import { User } from "src/app/auth/model/user";
import { UserService } from "../service/user.service";
import { TranslateService } from "@ngx-translate/core";
import { AppState } from "src/app/store/index.selector";
import { DialogRef, DialogService } from "@ngneat/dialog";
import { PopupType } from "src/app/shared/enums/popup-types";
import { MessagePortalComponent } from "src/app/portal/portal";
import { showMessage } from "src/app/shared/utils/toast.popup";
import { TableService } from "src/app/shared/services/table.service";
import { slideDownUp, toggleAnimation } from "src/app/shared/animations";
import { PositioningService } from "src/app/shared/services/positioning.service";
import { Component, ElementRef, inject, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { BaseTableComponent, DatatableColumn } from "../../../shared/components/base-table/base-table.component";

@Component({
  selector: "app-users-table",
  templateUrl: "./users.table.component.html",
  animations: [slideDownUp, toggleAnimation],
  standalone: false,
})
export class UsersTableComponent extends BaseTableComponent<User> implements OnInit {
  @ViewChild("addUserModalTemplate") addUserModalTemplate!: TemplateRef<unknown>;
  @ViewChild("datatable") datatable: any;
  @ViewChild("dropdownPlaceholder") dropdownPlaceholder!: ElementRef;
  @ViewChild(MessagePortalComponent) messagePortalComponent!: MessagePortalComponent;

  addUserModal!: DialogRef;
  private dialog = inject(DialogService);

  isLoading = false;
  searchText = "";
  editId?: number;

  constructor(
    public override translate: TranslateService,
    public override store: Store<AppState>,
    public override tableService: TableService,
    private positioningService: PositioningService,
    private userService: UserService,
  ) {
    super(store, tableService, `accounts/paginated`, translate);
  }

  isShowTaskMenu = false;
  isSetConfigChecked = false;

  override ngOnInit(): void {
    super.ngOnInit();
  }

  getColumns(): void {
    this.cols = [
      { field: "id", title: "Id", sort: true, hide: true } as DatatableColumn,
      { field: "name", title: this.translate.instant("users_page.name"), sort: true } as DatatableColumn,
      { field: "email", title: this.translate.instant("users_page.email"), sort: true } as DatatableColumn,
      { field: "role", title: this.translate.instant("users_page.role"), sort: true } as DatatableColumn,
      { field: "createdAt", title: this.translate.instant("users_page.created_at"), sort: true } as DatatableColumn,
      { field: "actions", title: this.translate.instant("contract.actions"), sort: true } as DatatableColumn,
    ];
  }

  addTask(userId: number | undefined = undefined) {
    this.editId = userId;
    this.addUserModal = this.dialog.open(this.addUserModalTemplate, {
      id: `dialog-${crypto.randomUUID()}`,
    });
  }

  closeCreateModal() {
    this.addUserModal.close();
    this.fetchItems(this.getPaginationParams());
  }

  openDeleteModal(id: number) {
    Swal.fire({
      icon: "warning",
      title: this.translate.instant("users_page.confirm_delete"),
      showCancelButton: true,
      confirmButtonText: this.translate.instant("Yes"),
      cancelButtonText: this.translate.instant("No"),
      customClass: {
        confirmButton: "swal2-confirm btn btn-primary",
        cancelButton: "swal2-cancel btn btn-secondary",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        this.isLoading = true;
        const deleteSub = this.userService.deleteUser(id).subscribe({
          next: () => {
            deleteSub.unsubscribe();
            showMessage(PopupType.Success, this.translate.instant("users_page.successfull_delete"));
            this.fetchItems(this.getPaginationParams());
          },
          error: () => {
            deleteSub.unsubscribe();
            showMessage(PopupType.Danger, this.translate.instant("users_page.invalid_delete"));
          },
        });
      }
    });
  }

  setSearchText(text: string) {
    setTimeout(() => {
      this.search = text;
    });
  }

  onPortalAttached() {
    setTimeout(() => {
      this.positioningService.setPosition(this.dropdownPlaceholder, this.messagePortalComponent);
    }, 0);
  }
}
